import * as Api from '@ViewModels';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { ADMIN_ACCOUNT_QUERY_KEY } from '../Admin/Account/useAdminAccountQuery';

export const useSetGoogleBusinessBrandingSettings = ({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext?: Api.IImpersonationContext;
	onError?: (err: Api.IOperationResultNoValue) => void;
	onSuccess?: () => void;
}) => {
	const userSession = useUserSession();
	const queryClient = useQueryClient();
	const effectiveImpersonationContext = impersonationContext ?? userSession.impersonationContext;

	return useMutation({
		mutationFn: (brandingSettings: Api.IGoogleBusinessBrandingSettings) => {
			return userSession.webServiceHelper.callAsync(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext: effectiveImpersonationContext,
					urlPath: 'account/preferences/googleReviewPostBranding',
				}),
				'PUT',
				brandingSettings
			);
		},
		onError,
		onSuccess: () => {
			const accountId = effectiveImpersonationContext?.account?.id ?? userSession.account?.id;
			if (accountId) {
				queryClient.invalidateQueries({ queryKey: [ADMIN_ACCOUNT_QUERY_KEY, accountId] });
			}
			onSuccess?.();
		},
	});
};
